import SearchSimple from "../../../../../components/SearchSimples/SearchSimple"
import CustomTable from "../../../../../components/table/CustomTable"
import MyOrdersTableApp from "../../Functionality/MyOrdersTableApp"

/**
 * MyOrdersTable Component
 *
 * Renders the "My Orders" table page, including the search bar and results table for user orders.
 * Utilizes the custom hook MyOrdersTableApp to manage table state, pagination, and data fetching.
 *
 * @author      Jhovanny Fragoso Marquez
 * @jobTitle    Frontend Developer
 * @email       jfragoso@ibl.mx
 *
 * @component
 * @returns {JSX.Element} The rendered component with search input and paginated orders table.
 */


const MyOrdersTable = () => {

  const {
    supplierId,
    thead,
    tbody,
    pagination,
    results,
    searchElement,
    setSearchElement,
    option,
    rowsPerPage,
    setSearch,
    simpleSearch,
    setSimpleSearch,
    contractorId,
    setResults,
    searchId,
    tableId
  } = MyOrdersTableApp()



  return (
    <>
        <SearchSimple
            id={searchId}
            setBodyForExport={() => { }}
            setSearchResults={setResults}
            searchResults={results}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            optionTable={option}
            rowsPerPage={rowsPerPage}
            setSearch={setSearch}
            simpleSearch={simpleSearch}
            setSimpleSearch={setSimpleSearch}
            contractorId={contractorId}
            supplierId={supplierId}
        />
        <CustomTable
            tableId={tableId}
            searchId={searchId}
            thead={thead}
            tbody={tbody}
            columnActions={false}
            textNotInformation='no_orders'
            withoutHeight={false}
        />
        {pagination()}
    </>

  )
}

export default MyOrdersTable
